<template>
    <v-sheet color="bgtopology" width="100%"  class="defaultCard">
        <v-row class="ma-0" justify="space-between" style="align-items: self-end !important;">
            <v-col cols="10">
                <v-sheet color="transparent">
                    <h2> {{ t('labels.addTitle')}}</h2>
                </v-sheet>
            </v-col>
            <v-col cols="1">
                <v-btn icon="mdi-close" variant="plain" @click="emitDialogClose()"></v-btn>
            </v-col>                    
        </v-row>
        <v-divider class="mt-4 mb-7"></v-divider>
        <v-form v-model="valid" >
            <v-row>

                <!-- IP Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-text-field
                        v-model="ip"
                        :label="t('labels.ip') + ' *'"                        
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-text-field>
                </v-col>  

                <!-- Tag Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-text-field
                        v-model="tag"
                        :label="t('labels.name') + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-text-field>
                </v-col>

                <!-- Mark Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="mark"
                        :items="finalMark"
                        :label="t('labels.mark')  + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select> 
                </v-col>

                <!-- Subtype Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="rol"
                        :items="finalSubtype"
                        :label="t('labels.subtype')  + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select>
                </v-col>

                <!-- type Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="type"
                        :items="finalType"
                        :label="t('labels.type')  + ' *'"
                        variant="underlined"
                        density="compact"
                        :rules="fieldRules"
                    ></v-select>
                </v-col>
                
                <!-- SNMP Config Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="3" lg='3' xl="3">
                    <v-select
                        v-model="snmp_conf"
                        :items="finalSNMP"
                        :label="t('labels.snmp_conf')"
                        variant="underlined"
                        density="compact"
                    ></v-select>
                </v-col>

                
                <!-- Observation Field -->
                <v-col :class="xs?'pa-0':null" cols="12" sm="4" md="6" lg='6' xl="6">
                    <v-text-field
                        v-model="anotacion"
                        :label="t('labels.annotation')"
                        variant="underlined"
                        density="compact"
                    ></v-text-field>
                </v-col>    

                <!-- GPS Field -->
                <v-col cols="12" class='px-2'>
                    <v-row class="ma-0">
                        <v-col cols="12" sm="4" md="3" lg='3' xl="3" class='pa-0 pl-0 pr-2'>
                            <v-text-field
                            v-model="latitude"
                            :label="t('labels.latitude')"
                            variant="underlined"
                            density="compact"
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="3" lg='3' xl="3" class='pa-0 px-2'>
                            <v-text-field
                            v-model="longitude"
                            :label="t('labels.longitude')"
                            variant="underlined"
                            density="compact"
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="3" lg='3' xl="3" class='pa-0 px-2'>
                            <v-text-field
                            v-model="altitude"
                            :label="t('labels.altitude')"
                            variant="underlined"
                            density="compact"
                        ></v-text-field>
                        </v-col>
                    </v-row>                    
                </v-col> 

            </v-row>
            
            <v-btn  @click="addItem()" :disabled="(!valid && valid !== null && valid !== undefined)" class="mt-10" prepend-icon="mdi-check-circle" color="success" block>
                {{ t('buttons.add' )}}
            </v-btn>
        </v-form>
    </v-sheet>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import axios from 'axios';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
const { xs } = useDisplay();

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
import { APIS_INVENTORY } from '@/constants/apis';
import { TOKEN } from '@/constants/labels';

/********************************
 *********** FUNCTION ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';

const props = defineProps({
    itemObject   : { required:true, type:Object },
    arraySubtype : { required:true, type:Array },
    arrayType    : { required:true, type:Array },
    arrayMark    : { required:true, type:Array },
    arraySNMP    : { required:true, type:Array }
})
const emits = defineEmits( ['closeCopyDialog'] );
        

const finalItem     = computed(() => props.itemObject);
const finalSubtype  = computed(() => props.arraySubtype);
const finalType     = computed(() => props.arrayType);
const finalMark     = computed(() => props.arrayMark);
const finalSNMP     = computed(() => props.arraySNMP);

const ip            = ref(finalItem.value.ip);
const tag           = ref(finalItem.value.tag);
const mark          = ref(finalItem.value.marca);
const rol           = ref(finalItem.value.rol);
const type          = ref(finalItem.value.tipo);
const snmp_conf     = ref(finalItem.value.snmp_conf??'0');
const anotacion     = ref(JSON.stringify(finalItem.value.anotacion??{}));
// const gps           = ref(finalItem.value.gps);
const gps           = ref(finalItem.value.gps??{"latitud" : 0, "longitud" : 0, "altitud" : 0});
const valid         = ref(true);
const params        = ref({});


const latitude      = ref(gps.value.latitud);
const longitude     = ref(gps.value.longitud);
const altitude      = ref(gps.value.altitud);

const api           = APIS_INVENTORY.value.postAddInventoryData;

const emitDialogClose = () => {
    emits('closeCopyDialog');
}
        
const addItem = async () => {

    await getParams();

    await axios.post(api,params.value, { headers: { "Authorization": `Bearer ${TOKEN}` } }).then((response) =>{

        if(!response.data.error){

            store.dispatch('getInventoryData'); 
            store.dispatch('showSnackBar', {type: 'setSnackAdd', msg: t('snackbar.add')});

        }
        else{
            showErrorSnackBar('snackbar.errorAdd');
        }
    })
    .catch(function (error) {
        showConsoleError(error);
        showErrorSnackBar('snackbar.errorAdd');
    });
}


const showErrorSnackBar = (errorMsg:string) => {

    store.dispatch('showSnackBar', {type: 'setSnackError', msg: t(`${errorMsg}`)});

}


const getParams = async () => {
    let finalGPS = {
        "latitud"  : parseFloat(latitude.value),
        "longitud" : parseFloat(longitude.value),
        "altitud"  : parseFloat(altitude.value),
    }
    params.value = {
        ip          : ip.value,
        tag         : tag.value,
        marca       : mark.value,
        tipo        : type.value,
        rol         : rol.value,
        snmp_conf   : parseInt(snmp_conf.value),
        anotacion   : anotacion.value,
        gps         : JSON.stringify(finalGPS),
    }
}

const fieldRules    = computed ( () => [ (v:string) => !!v ||  t('labels.error.required') ]);

</script>